import { useMutation, useQueryClient } from "react-query";
import { getHeaderAuthBearerToken } from "utils/requests/auth";
import { webApi } from "services/api/config";
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'hooks/UseSnackbar';

export function useMutationDeleteScholarshipRecess(id) {
  const queryClient = useQueryClient();
  const [t] = useTranslation();
  const toast = useSnackbar();

  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await webApi.put(`api/ScholarshipRecessHistory/disable/${id}`, payload, {
        headers: {
          Authorization: getHeaderAuthBearerToken(),
          'Content-Type': 'application/json',
        },
      });
      return data;
    },
    onSuccess: () => {
      toast.success(t("HR.recessPeriodDeleteSuccess"));
      queryClient.invalidateQueries(["useGetScholarshipHistory"]);
    },
    onError: (error) => {
      const errorMessage =
        error.status === 500
          ? t("HR.recessPeriodDeleteError")
          : error.response?.data?.message || error.message;
      toast.error(errorMessage);
    },
  });
}
